import React, { Component } from 'react'
import { Form, Row, Col, Alert } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable, action } from 'mobx'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { isNumeric } from '../../../utils/objectutils'
import trash from '../../../assets/icons/trash.svg'
import copy from '../../../assets/icons/copy.png'
import { Link } from 'react-router-dom'
import VariantView from './VariantView'
import SerialkeyView from './SerialkeyView'
import BatchkeyView from './BatchkeyView'
import ExpiryDateView from './ExpiryDateView'
import WarrantyDateView from './WarrantyDateView'
import { getIsoDate } from '../../../utils/getIsoDate'
import { isEmptyDate } from '../../../utils/emptyDate'
import { colors } from '../../../styles/colors'
import { getMetaProperty } from '../../../utils/customerPrototypes'

const StyledWrapper = styled.div`
  padding: 10px;
  flex-grow: 1;
  border-bottom: 1px solid ${colors.gray3};
`
const StyledDisabled = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const QuantityAndButtonsRow = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
  .action-buttons-desktop a {
    margin-left: 10px;
  }

  @media (max-width: 567px) {
    .quantity-expected-mobile {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .quantity-expected-mobile input {
      width: 100%;
    }
  }

  @media (max-width: 567px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;

    a {
      width: 100% !important;
      flex: 1 !important;
    }

    align-items: end;
  }

  @media (min-width: 568px) {
    display: flex;
    gap: 10px;
  }
`

const LinksRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`

const StyledRemoveLink = styled(Link)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #ff0000;
  background-color: #ffe5e5;
  border: 1px solid #ffb3b3;
  border-radius: 6px;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 0.9em;

  &:hover {
    background-color: #ffd6d6;
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${trash}) center center no-repeat;
    background-size: contain;
  }
  @media (max-width: 567px) {
    flex: 0;
    width: auto;
    padding: 6px 10px;
    white-space: nowrap;
  }
`

const StyledCopyLink = styled(Link)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #000000;
  background-color: #f0f0f0;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 0.9em;

  &:hover {
    background-color: #e2e2e2;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${copy}) center center no-repeat;
    background-size: contain;
  }
  @media (max-width: 567px) {
    flex: 0;
    width: auto;
    padding: 6px 10px;
    white-space: nowrap;
  }
`
class PositionItem extends Component {
  validationError = null
  quantityExpected = null
  quantityCounted = null
  serialkey = null
  batchkey = null
  expiryDate = null
  warrantyDate = null
  oldValue = null
  enforceUpdate = false
  constructor(props) {
    super(props)

    makeObservable(this, {
      validationError: observable,
      quantityExpected: observable,
      quantityCounted: observable,
      serialkey: observable,
      batchkey: observable,
      expiryDate: observable,
      warrantyDate: observable,
      oldValue: observable,
      enforceUpdate: observable,
      init: action,
      setPropValue: action,
    })

    this.init()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { position } = this.props
    if (
      !!this.enforceUpdate ||
      (!!prevProps && this.positionHasChanged(prevProps.position, position))
    ) {
      this.init()
    }
  }
  init = () => {
    const { position } = this.props
    this.quantityExpected = position.quantityExpected
    this.quantityCounted = position.quantityCounted
    this.serialkey = position.serialkey
    this.batchkey = position.batchkey
    this.expiryDate = !isEmptyDate(position.expiryDate)
      ? new Date(position.expiryDate)
      : ''
    this.warrantyDate = !isEmptyDate(position.warrantyDate)
      ? new Date(position.warrantyDate)
      : ''
    this.enforceUpdate = false
  }
  positionHasChanged = (oldPosition, newPosition) => {
    const oldPositionsString = JSON.stringify(oldPosition)
    const newPositionsString = JSON.stringify(newPosition)
    return oldPositionsString !== newPositionsString
  }
  getValidationInfo = () => {
    const { position } = this.props
    const { validation } = position
    let msg = null
    let errorDetails = []

    if (validation) {
      validation.forEach((error) => {
        switch (error.source) {
          case '/serialkey':
            if (!position.serialkey) errorDetails.push(error.detail)
            break
          case '/batchkey':
            if (!position.batchkey) errorDetails.push(error.detail)
            break
          case '/expiryDate':
            if (isEmptyDate(position.expiryDate))
              errorDetails.push(error.detail)
            break
          case '/warrantyDate':
            if (isEmptyDate(position.warrantyDate))
              errorDetails.push(error.detail)
            break
          default:
            break
        }
      })
    }
    if (errorDetails.length) {
      msg = errorDetails.join('\n\n')
    }
    return msg
  }
  getValidationError = () => {
    const { position } = this.props
    const { errors } = position
    let msg = null
    let errorDetails = []

    if (errors) {
      errors.forEach((error) => {
        switch (error.source) {
          case '/serialkey':
            errorDetails.push(error.detail)
            break
          case '/batchkey':
            errorDetails.push(error.detail)
            break
          case '/expiryDate':
            errorDetails.push(error.detail)
            break
          case '/warrantyDate':
            errorDetails.push(error.detail)
            break
          default:
            break
        }
      })
    }
    if (errorDetails.length) {
      msg = errorDetails.join('\n\n')
    }
    return msg
  }
  fieldIsDisabled = (name) => {
    const { position } = this.props
    let disabled = false
    switch (name) {
      case 'serialkey':
      case 'batchkey':
      case 'expiryDate':
      case 'warrantyDate':
      case 'articleVariant':
      case 'article':
      case 'quantityExpected':
      case 'quantityCounted':
        disabled = getMetaProperty(
          position.metaProperties,
          `/${name}`,
          'isReadOnly'
        )
        break
      default:
        break
    }
    if (position.hasInstance && (name === 'expiryDate' || name === 'warrantyDate')) disabled = true
    return !!disabled
  }
  onClickRemove = async (e) => {
    const { position, handleDeletePosition } = this.props
    e.preventDefault()
    handleDeletePosition(position.id)
  }
  onClickCopy = async (e) => {
    const { position, handleCopyPosition } = this.props
    e.preventDefault()
    handleCopyPosition(position.id)
  }
  handleOnChangeVariant = async (variant) => {
    this.changePositionByKey('articleVariant', variant.id)
  }
  handleOnChangeDate = (name) => (date) => {
    this.setPropValue(name, date)
    let value = (date && getIsoDate(date)) || ''
    this.changePositionByKey(name, value)
  }
  handleOnFocus = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnFocus", value, e, id)
    e.preventDefault()
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges('oldValue', value)
        break
      case 'serialkey':
      case 'batchkey':
        break
      default:
        break
    }
  }
  handleOnBlur = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnBlur", value, e, id)
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges(name, value, this.oldValue, true)
        break
      case 'serialkey':
      case 'batchkey':
        this.updateKeyChanges(name, value)
        break
      default:
        break
    }
  }
  handleOnChange = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnChange", value, e, id)
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
        this.updateQuantityChanges(name, value)
        break
      case 'serialkey':
      case 'batchkey':
        this.setPropValue(name, value)
        break
      default:
        break
    }
  }
  handleOnKeyDown = async (e) => {
    if (e.key === 'Enter') {
      const { value, name, id } = e.target
      e.preventDefault() //ENTER key on keyboard and page refreshes
      const { handleNextFocus } = this.props
      switch (name) {
        case 'quantityExpected':
        case 'quantityCounted':
          this.updateQuantityChanges(name, value, this.oldValue, true)
          handleNextFocus(id, name)
          break
        case 'serialkey':
        case 'batchkey':
          await this.updateKeyChanges(name, value)
          handleNextFocus(id, name)
          break
        default:
          break
      }
    }
  }
  setPropValue = (name, value) => {
    this[name] = value
  }
  updateQuantityChanges = async (
    name,
    value,
    defVal = '',
    updatePosition = false
  ) => {
    const { position } = this.props
    let isValid = false
    let validValue = defVal
    if (isNumeric(value)) {
      validValue = parseInt(value)
      isValid = validValue >= 0
    }
    if (!isValid) {
      validValue = defVal
    }
    switch (name) {
      case 'quantityExpected':
      case 'quantityCounted':
      default:
        this.setPropValue(name, validValue)
        break
    }
    if (!!updatePosition) {
      this.changePositionByKey(name, value)
      if (
        !!position.article.useSerialKeys &&
        !!position.serialkey &&
        this.quantityExpected > 1
      ) {
        //this.splitPosition()
        this.changePositionByKey('serialkey', '')
        this.setPropValue('enforceUpdate', true)
      }
    }
    //console.log("updateQuantityChanges", value, isNumeric(value), this[name], name, validValue)
  }
  updateKeyChanges = async (name, value) => {
    await this.changePositionByKey(name, value)
    switch (name) {
      case 'serialkey':
        if (!!value && this.quantityExpected > 1) {
          this.splitPosition()
        }
        break
      default:
        break
    }
  }
  changePositionByKey = async (name, value) => {
    const { position, index, handleChangePositionByKey, resetErrorByFormKey } =
      this.props
    handleChangePositionByKey(position.id, name, value)
    resetErrorByFormKey(`positions${index}${name}`)
    await this.checkInstance(name)
  }
  checkInstance = async (name) => {
    const { position, handleCheckInstance, handleChangePositionByKey } = this.props
    switch (name) {
      case 'serialkey':
      case 'batchkey':
        let result = await handleCheckInstance(position.id, name)
        if(result)
        {
          
          handleChangePositionByKey(position.id, 'expiryDate', result.expiryDate)
          handleChangePositionByKey(position.id, 'warrantyDate', result.warrantyDate)
        }
        handleChangePositionByKey(position.id, 'hasInstance', !!result)
        break
      default:
        break
    }
    
    this.setPropValue('enforceUpdate', true)
  }
  splitPosition = async (splitQuantity = 1) => {
    const { position, handleSplitPosition } = this.props
    handleSplitPosition(position.id, splitQuantity)
    this.setPropValue('enforceUpdate', true)
  }
  getInputId(name) {
    const { position, index } = this.props
    switch (name) {
      case 'quantityExpected':
        return `${position.id}-qe_${index}`
      case 'quantityCounted':
        return `${position.id}-qc_${index}`
      case 'serialkey':
        return `${position.id}-sk_${index}`
      case 'batchkey':
        return `${position.id}-bk_${index}`
      case 'expiryDate':
        return `${position.id}-ed_${index}`
      case 'warrantyDate':
        return `${position.id}-wd_${index}`
      case 'articleVariant':
        return `${position.id}-av_${index}`
      default:
        return `${position.id}-${index}`
    }
  }
  getFormError(name) {
    const { formErrors, index } = this.props
    return formErrors[`positions${index}${name}`]
  }
  renderVariantView() {
    const { position } = this.props
    const { article, articleVariant } = position
    const name = 'articleVariant'
    return (
      <VariantView
        id={this.getInputId(name)}
        articleId={article.id}
        selectedVariant={articleVariant}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChangeVariant}
        formError={this.getFormError(name)}
      />
    )
  }
  renderSerialkeyView() {
    const name = 'serialkey'
    return (
      <SerialkeyView
        id={this.getInputId(name)}
        serialkey={this.serialkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderBatchkeyView() {
    const name = 'batchkey'
    return (
      <BatchkeyView
        id={this.getInputId(name)}
        batchkey={this.batchkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderExpiryDateView() {
    const name = 'expiryDate'
    return (
      <ExpiryDateView
        id={this.getInputId(name)}
        expiryDate={this.expiryDate}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChangeDate}
        formError={this.getFormError(name)}
      />
    )
  }
  renderWarrantyDateView() {
    const name = 'warrantyDate'
    return (
      <WarrantyDateView
        id={this.getInputId(name)}
        warrantyDate={this.warrantyDate}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChangeDate}
        formError={this.getFormError(name)}
      />
    )
  }
  renderQuantityExpected() {
    const { position } = this.props
    const name = 'quantityExpected'
    const disabled = this.fieldIsDisabled(name)
    const formError = this.getFormError(name)
    return (
      <>
        {!disabled ? (
          <>
            <Form.Control
              id={this.getInputId(name)}
              name={name}
              type='number'
              value={this.quantityExpected}
              onChange={this.handleOnChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onKeyDown={this.handleOnKeyDown}
              min={0}
              max={position.useSerialKeys ? 1 : null}
              isInvalid={!!formError}
              disabled={!!disabled}
            />
            <Form.Control.Feedback type='invalid'>
              {formError}
            </Form.Control.Feedback>
          </>
        ) : (
          <StyledDisabled>{this.quantityExpected}</StyledDisabled>
        )}
      </>
    )
  }
  renderQuantityCounted() {
    const { position } = this.props
    const name = 'quantityCounted'
    const disabled = this.fieldIsDisabled(name)
    const formError = this.getFormError(name)
    return (
      <>
        {!disabled ? (
          <>
            <Form.Control
              id={this.getInputId(name)}
              name={name}
              type='number'
              value={this.quantityCounted}
              onChange={this.handleOnChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onKeyDown={this.handleOnKeyDown}
              min={0}
              max={position.useSerialKeys ? 1 : this.quantityExpected}
              isInvalid={!!formError}
              disabled={!!disabled}
            />
            <Form.Control.Feedback type='invalid'>
              {formError}
            </Form.Control.Feedback>
          </>
        ) : (
          <StyledDisabled>{this.quantityCounted}</StyledDisabled>
        )}
      </>
    )
  }
  renderActionButtons() {
    const { t, deletable, isStoring } = this.props
    return (
      <LinksRow>
        {!!deletable && (
          // <Row>
          <StyledRemoveLink to={'#'} onClick={this.onClickRemove} tabIndex={-1}>
            {t('deleteButton')}
          </StyledRemoveLink>
          // </Row>
        )}
        {!isStoring && (
          // <Row>
          <StyledCopyLink to={'#'} onClick={this.onClickCopy} tabIndex={-1}>
            {t('officeAdmin:copy')}
          </StyledCopyLink>
          // </Row>
        )}
      </LinksRow>
    )
  }
  renderHeader(title) {
    return <div className='fw-bold'>{title}</div>
  }
  renderTableItem() {
    const { position, isStoring } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    return (
      <>
        <tr>
          <td>
            {!!position.isNewPosition && '* '}
            {article.articleNumber}
          </td>
          <td>{article.displayName}</td>
          <td>
            {!!article.isWithSizes && this.renderVariantView()}
            {!article.isWithSizes && <div>---</div>}
          </td>
          <td>
            {!!isStoring && (
              <div className='fw-bold'>{this.quantityExpected}</div>
            )}
            {!isStoring && this.renderQuantityExpected()}
          </td>
          {!!isStoring && <td>{this.renderQuantityCounted()}</td>}
          <td>{this.renderActionButtons()}</td>
        </tr>
        {(!!article.useSerialKeys || !!article.useBatchKeys) && (
          <tr>
            <td colSpan='5'>
              <Row>
                {!!article.useSerialKeys && (
                  <Col>{this.renderSerialkeyView()}</Col>
                )}
                {!!article.useBatchKeys && (
                  <Col>{this.renderBatchkeyView()}</Col>
                )}
                {!!article.isWithExpiry && (
                  <Col>{this.renderExpiryDateView()}</Col>
                )}
                {!!article.isWithWarranty && (
                  <Col>{this.renderWarrantyDateView()}</Col>
                )}
              </Row>
            </td>
          </tr>
        )}
        {this.validationError && (
          <tr>
            <td colSpan='4'>
              <Alert variant='danger' className='mb-3'>
                {this.validationError}
              </Alert>
            </td>
          </tr>
        )}
        {validationInfo && (
          <tr>
            <td colSpan='4'>
              <Alert variant='info' className='mb-3'>
                {validationInfo}
              </Alert>
            </td>
          </tr>
        )}
      </>
    )
  }
  renderListItem() {
    const { t, position, isStoring, deletable } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    const validationError2 = this.getValidationError()
    return (
      <React.Fragment>
        <StyledWrapper>
          <Row>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('productDetail:articleNumber'))}
              <div>
                {!!position.isNewPosition && '* '}
                {article.articleNumber}
              </div>
            </Col>
            <Col lg='3' sm='3'>
              {this.renderHeader(t('productDetail:articleDescription'))}
              <div>{article.displayName}</div>
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('size'))}
              {!!article.isWithSizes && this.renderVariantView()}
              {!article.isWithSizes && <div>---</div>}
            </Col>
            <MediaQuery minWidth={567}>
              <Col lg='2' sm='3'>
                {this.renderHeader(t('goodsReceiptPage:quantityExpected'))}
                {!!isStoring && (
                  <div className='fw-bold'>{this.quantityExpected}</div>
                )}
                {!isStoring && this.renderQuantityExpected()}
              </Col>
            </MediaQuery>
            {!!isStoring && (
              <Col lg='2' sm='3'>
                {this.renderHeader(t('goodsReceiptPage:quantityCounted'))}
                {this.renderQuantityCounted()}
              </Col>
            )}
            <MediaQuery minWidth={568}>
              <Col lg='12'>
                <Row>
                  <Col lg='3' md='3'></Col>
                  <Col lg='3' md='3'></Col>
                  <Col lg='6' md='6' className='mt-2 action-buttons-desktop'>
                    {this.renderActionButtons()}
                  </Col>
                </Row>
              </Col>
            </MediaQuery>

            <MediaQuery maxWidth={567}>
              <Col sm='12'>
                <QuantityAndButtonsRow>
                  {/* Menge (quantityExpected) */}
                  <div className='quantity-expected-mobile'>
                    {this.renderHeader(t('goodsReceiptPage:quantityExpected'))}
                    {this.renderQuantityExpected()}
                  </div>

                  {/* Delete */}
                  {!!deletable && (
                    <StyledRemoveLink
                      to='#'
                      onClick={this.onClickRemove}
                      tabIndex={-1}
                    >
                      {t('deleteButton')}
                    </StyledRemoveLink>
                  )}

                  {/* Copy */}
                  {!isStoring && (
                    <StyledCopyLink
                      to='#'
                      onClick={this.onClickCopy}
                      tabIndex={-1}
                    >
                      {t('officeAdmin:copy')}
                    </StyledCopyLink>
                  )}
                </QuantityAndButtonsRow>
              </Col>
            </MediaQuery>
          </Row>
          {(!!article.useSerialKeys || !!article.useBatchKeys) && (
            <Row>
              {!!article.useSerialKeys && (
                <Col>{this.renderSerialkeyView()}</Col>
              )}
              {!!article.useBatchKeys && <Col>{this.renderBatchkeyView()}</Col>}
              {!!article.isWithExpiry && (
                <Col>{this.renderExpiryDateView()}</Col>
              )}
              {!!article.isWithWarranty && (
                <Col>{this.renderWarrantyDateView()}</Col>
              )}
            </Row>
          )}
          {this.validationError && (
            <Alert variant='danger' className='mb-3'>
              {this.validationError}
            </Alert>
          )}
          {validationError2 && (
            <Alert variant='danger' className='mb-3'>
              {validationError2}
            </Alert>
          )}
          {validationInfo && (
            <Alert variant='info' className='mb-3'>
              {validationInfo}
            </Alert>
          )}
        </StyledWrapper>
      </React.Fragment>
    )
  }

  render() {
    const { enforceListView } = this.props
    return (
      <>
        {!!enforceListView ? (
          this.renderListItem()
        ) : (
          <>
            {<MediaQuery maxWidth={998}>{this.renderListItem()}</MediaQuery>}
            {<MediaQuery minWidth={999}>{this.renderTableItem()}</MediaQuery>}
          </>
        )}
      </>
    )
  }
}

export default withTranslation()(observer(PositionItem))
